module.exports = __webpack_public_path__ + "img/Android_Female_talking.223cdece.png";